'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Loading
 * @returns {React.Element} Returns JSX of loading dots
 * @public
 */
var Loading = function Loading(_ref) {
  var dark = _ref.dark;

  var spanProps = {
    className: dark && 'dark'
  };

  return _react2.default.createElement(
    'div',
    { className: 'loading-dots' },
    _react2.default.createElement('span', spanProps),
    _react2.default.createElement('span', spanProps),
    _react2.default.createElement('span', spanProps)
  );
};

/**
 * Property definitions.
 *
 * @type {Object}
 * @private
 */
Loading.propTypes = {
  dark: _propTypes2.default.bool
};

exports.default = Loading;